import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const SELECTOR_Button_Pager = ".btn-pager";
const SELECTOR_SCROLL_ELEMENT = ".scroll";
const SELECTOR_RESULT_WRAPPER = ".results-wrapper";
const SELECTOR_TECH_SPEC_CONTAINER = ".technical-specifications-container";
const SELECTOR_SCROLL_LABEL = ".scroll div.label";
const SELECTOR_FLEX_CONTAINER = ".scroll .flex-container";
const SELECTOR_PRODUCT_IMAGE = ".product-image";
const SELECTOR_BUTTON_DELETE = ".button-delete";

export default class PerformanceCurvesDom extends DomElementsBase {
	constructor($module) {
		const selectors = [SELECTOR_Button_Pager];

		super($module, selectors);

		this.$btnPager = this.getElements(SELECTOR_Button_Pager);
	}

	getButtonPager() {
		return this.$btnPager;
	}

	getScrollElement() {
		return this.getElement(SELECTOR_SCROLL_ELEMENT);
	}

	getResultWrapper() {
		return this.getElement(SELECTOR_RESULT_WRAPPER);
	}

	getScrollContainerLabel() {
		return this.getElement(SELECTOR_SCROLL_LABEL);
	}

	getTechSpecContainer() {
		return document.querySelector(SELECTOR_TECH_SPEC_CONTAINER);
	}

	getProductImageList() {
		return this.getElement(SELECTOR_FLEX_CONTAINER).querySelectorAll(SELECTOR_PRODUCT_IMAGE);
	}

	getDeleteButtons() {
		return this.getElements(SELECTOR_BUTTON_DELETE);
	}
}
